import Vue from 'vue';
import Vuex from 'vuex';
import LookupModule from '@/store/lookup-store';
import UserModule from '@/store/user-module';
import StopwatchModule from '@/store/stopwatch-store';
import TimeEntryModule from '@/store/time-entry-store';
import AccountModule from '@/store/account-module';

Vue.use(Vuex);

export interface RootState {
  lookupStateModule: LookupModule;
  userStateModule: UserModule;
  stopwatchStateModule: StopwatchModule;
  timeEntryStateModule: TimeEntryModule;
  accountStateModule: AccountModule;
}

export default new Vuex.Store<RootState>({});
